import React, { useEffect, useState } from 'react';
import styles from './ShowUnknownErrorPanel.module.scss';
import { OpenChatBot } from 'utils/chatBot';

interface Props {
    PageData?: any;
    Model?: any;
    onClose:()=>void;
}

const ShowUnknownErrorPanel = ({ PageData, Model,onClose}: Props) => {
    const liveBtn = () => {
        // OpenChatBot;
        let anyQuestionsText = PageData?.AnyQuestionsButtonText;
        OpenChatBot(Model?.WebchatPageUrl, anyQuestionsText);
    };
    return  (
        <div className={styles.section}>
            <div className="modal-overlay is-active">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <a className="modal-close" onClick={()=>{onClose();}}></a>
                        <div className="modal-header"> {PageData.RegistrationUnknownErrorHeading}</div>
                        <div className="modal-body u-center">
                            <p className="modal-para">
                                {PageData.RegistrationUnknownErrorContent}
                            </p>
                            <div className="Grid">
                                <div className="Grid-cell">
                                    <button className="Button u-block u-marginBxxsm w-100" id="ok-button" onClick={()=>{onClose();}}><span>{PageData.RegistrationTryAgainButtonText}</span></button>
                                    {(Model.IsGoLiveChatEnabled) &&
                                        (
                                            <button type="button" className="Button Button--ghost black-border u-block u-marginBxxsm w-100"
                                            onClick={() => {
                                                liveBtn();
                                            }}>
                                                <span>{PageData.RegistrationLiveChatButtonText}</span>
                                            </button>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShowUnknownErrorPanel;